import * as React from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { IToolProps, Tool } from "../Tool";
import { IBaseSubSectionProps } from "./IBaseSubSectionProps";
import "@metricell/smarttoolscore/dist/module/Styles/metricell.css";

export const ToolMenuSubSection: React.FunctionComponent<
    IBaseSubSectionProps
> = (props): React.ReactElement => {
    const bindOnClick = (): void => {
        props.bindSubSection(props.id);
    };

    const searchTools = (
        toolList: IToolProps[],
        searchTerm: string,
    ): IToolProps[] =>
        toolList.filter((t) =>
            t.name.toLowerCase().includes(searchTerm.toLowerCase()),
        );

    const filteredTools: IToolProps[] = searchTools(
            props.tools,
            props.searchQuery,
        ),
        toolList: React.ReactNode[] = [];

    for (let i = 0; i < filteredTools.length; i++) {
        toolList.push(
            <Tool
                bindToolToFrame={props.bindToolToFrame}
                key={filteredTools[i].moduleID}
                {...filteredTools[i]}
            />,
        );
    }

    const isActive: boolean = filteredTools.length > 0 && props.isActive;

    let subSectionClass = `section-subsection`;

    if (isActive) {
        subSectionClass += ` active`;
    }

    return (
        <CSSTransition
            classNames={`section-subsection`}
            in={isActive}
            timeout={200}
        >
            <div className={subSectionClass}>
                <div className={`subsection-title`} onClick={bindOnClick}>
                    {props.name}
                </div>
                <TransitionGroup component={null}>
                    {isActive && (
                        <CSSTransition
                            classNames={`subsection-toolcontainer`}
                            in={props.isActive}
                            timeout={200}
                        >
                            <div className={`scroll`}>
                                <div className={`subsection-toolcontainer`}>
                                    {toolList}
                                </div>
                            </div>
                        </CSSTransition>
                    )}
                </TransitionGroup>
            </div>
        </CSSTransition>
    );
};
